var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"add-user-btn",attrs:{"text":"","color":"var(--text)"},on:{"click":function($event){return _vm.handleClick($event)}}},[_c('v-icon',{staticClass:"add-user-icon"},[_vm._v("add_box")]),_vm._v("Add User")],1)}
var staticRenderFns = []

export { render, staticRenderFns }